export default __webpack_public_path__ + "static/media/GraphicDesign3.bdf1d948.png";